import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import {
  getInitPopUp,
  getTablebySql,
  getInitPopUpData,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTabHeader from "@shared/components/SnTabHeader";
import FreeForm from "@widgets/FreeForm";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { dateToString } from "@shared/utils/DateUtils";
import SnForm from "@widgets/SnForm";
interface popupProps {
  selectedData?: any;
  modalRef?: any;
}
interface RowData {
  KeyField?: string;

  [key: string]: any;
}
const SN_PRD_WMO_REG_002_TEX_POP_002 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const [gridFocus, setGridFocus] = useState(false);
    const [popupParent, setPopupParent] = useState<any>(null);
    const [sharedForm, setSharedForm] = useState<any[]>([]);
    const SharedFormref1 = useRef<any>();
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [formData, setFormData] = useState<any>();
    useImperativeHandle(ref, () => ({
      getSelectedValue: () => {
        onSave();
        return SharedFormref1.current.getFormdata();
      },
    }));
    //#endregion
    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);
    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_PRD_WMO_REG_002_TEX_POP_002",
            {}
          );
          setFormData(rtn.formData);
          setSharedForm(rtn.form.freeform1);
          setFormControlData(rtn.formControlData);
          await new Promise((resolve) => setTimeout(resolve, 0));
          await onSearch();
        } catch (error: any) {}
      };
      fetchform();
    }, []);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_prd_wmo_reg_002_tex_pop_02",
            params: {
              cd_firm: userInfo.cd_firm,
              no_wo: selectedData.data.no_wo,
              no_line: selectedData.data.no_line,
            },
          };

          const data: any = await fnGetDataSet(params);
          setFormData(data[0][0]);
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    const onSave = async () => {
      const data = SharedFormref1.current.getFormdata();

      const updateRow: any = {
        no_wo: selectedData.data.no_wo,
        cd_op: selectedData.data.cd_op,
        dt_wo: selectedData.data.dt_wo,
        qt_wo: selectedData.data.qt_wo,
        st_proc: selectedData.data.st_proc,
        yn_end: selectedData.data.yn_end,
        yn_sct: selectedData.data.yn_sct,
        yn_work: selectedData.data.yn_work,
        cd_firm: userInfo.cd_firm,
        no_line: selectedData.data.no_line,
      };
      const map = {
        dc_dlv: data.dc_dlv,
        dc_spec: data.dc_spec,
        dc_rmk02: data.dc_rmk02,
        dc_rmk03: data.dc_rmk03,
        st_no_po: selectedData.data.st_no_po,
      };
      updateRow.js_info = map;

      const SaveData = {
        prd_woproc_tex: {
          update: [updateRow],
          insert: [],
          delete: [],
        },
      };
      await fnSave("SN_PRD_WMO_REG_002_TEX_SAVE_02_POP", SaveData);
    };
    //#endregion

    return (
      <div className="h-full flex flex-col overflow-x-hidden">
        <div className="w-full h-full flex space-x-1">
          <div className="w-[80%] flex flex">
            <SnForm
              ref={SharedFormref1}
              data={formData}
              controls={sharedForm}
            ></SnForm>
          </div>
        </div>
      </div>
    );
  }
);

export default SN_PRD_WMO_REG_002_TEX_POP_002;
